<template>
  <div class="page-wrapper">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-position="top">
      <div class="form-wrapper">
        <el-form-item label="新闻标题" prop="title">
          <el-input
            class="w"
            maxlength="50"
            v-model="ruleForm.title"
            placeholder="请输入新闻标题"
          ></el-input>
        </el-form-item>
        <el-form-item label="新闻类目" prop="category">
          <el-input
            class="w"
            maxlength="10"
            v-model="ruleForm.category"
            placeholder="请输入新闻类目"
          ></el-input>
        </el-form-item>
        <el-form-item label="新闻摘要" prop="introduction">
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8}"
            class="w"
            v-model="ruleForm.introduction"
            placeholder="请输入新闻摘要"
          ></el-input>
        </el-form-item>
        <el-form-item label="发布时间" prop="displayTime">
          <el-date-picker
            v-model="ruleForm.displayTime"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="新闻主图（选填，官网“新闻资讯”页面第一条新闻展示，建议尺寸750x400像素）">
          <el-upload
            class="cg-img-uploader"
            :action="uploadFileApi"
            name="files"
            :data="uploadData"
            :show-file-list="false"
            :on-success="handleImgSuccess"
            :on-error="handleImgError"
            :before-upload="beforeImgUpload"
            accept="image/*">
            <el-image
              v-if="ruleForm.imgPath"
              class="cg-img"
              :src="ruleForm.imgPath"
              fit="cover"
            ></el-image>
            <!-- <img v-if="ruleForm.imageUrl" :src="ruleForm.imageUrl" class="cg-img"> -->
            <i v-else class="el-icon-plus cg-img-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="新闻内容" required>
            <editor :user-id="adminId" v-model="ruleForm.subject" :dataLoaded="editorDataLoaded"/>
        </el-form-item>
      </div>
    </el-form>
    <div class="bottom-btns-wrap">
      <el-button class="btn-large" type="primary" @click="submitForm">确认修改</el-button>
    </div>
  </div>
</template>

<script>
import { utils } from '@/common/common.js'
import editor from "../../components/Editor"
import { ajaxNews, NEWS_TYPE, FILE_TYPE, api } from '@/common/request_news.js'
import moment from 'moment'

export default {
  components: {
    editor
  },
  computed: {
    adminId() {
      return utils.getAdminId()
    },
  },
  inject: ["reload"],
  data() {
    return {
			detail: {},
      ruleForm: {
          title: "", // 标题
          type: NEWS_TYPE,  // 1 - 亿尚官网    2 - 综合体官网
          category: "", // 类目
          introduction: "", // 摘要
          subject: "", // 内容
          imgPath: "",
          displayTime: "", // 发布时间自定义
      },
			// 富文本编辑器是否已获取到数据
      editorDataLoaded: false,
      rules: {
        title: [
            { required: true, message: "请输入新闻名称", trigger: "change" }
        ],
        category: [
            { required: true, message: "请输入新闻类目", trigger: "change" }
        ],
        introduction: [
            { required: true, message: "请输入新闻摘要", trigger: "blur" }
        ],
        displayTime: [
          { required: true, message: "请输入发布时间", trigger: "change" }
        ]
      },
       // 上传图片api
      uploadFileApi: '',
      uploadData: {
        imageType: FILE_TYPE,
        imageUserId: ''
      },
    };
  },
  watch: {},
  created() {
    this.uploadFileApi = api.uploadUrl + '/file/uploadfilebatch';
    this.uploadData.imageUserId = this.adminId
    this.getDetail();
  },
  methods: {
    getDetail() {
        ajaxNews.get('/api/news/detail', {id: this.$route.query.id}).then(res=> {
            console.log(res)
						this.detail = res.data
						this.ruleForm.title = res.data.title
						this.ruleForm.category = res.data.category
						this.ruleForm.introduction = res.data.introduction
            this.ruleForm.imgPath = res.data.imgPath
						this.ruleForm.subject = res.data.subject
						this.editorDataLoaded = true
            let showDate = moment(res.data.displayTime);
            if (!showDate.isValid()) showDate = moment(res.data.createTime);
            if (!showDate.isValid()) showDate = new Date();
            this.ruleForm.displayTime = showDate;
        }).catch(err=> {
            console.log(err)
        })
    },
    // 提交新增新闻表单
    submitForm() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          if (this.ruleForm.subject.trim() == '') {
            this.$message.error('请填写新闻内容');
            return
          }
          let displayTime = moment(this.ruleForm.displayTime).format('YYYY-MM-DD');
          let params = {
            ...this.ruleForm,
            displayTime,
            userId: this.adminId,
            id: this.$route.query.id
          }
          
          console.log('params', params)
          ajaxNews.post('/api/news/update', params).then(res => {
            if (res.code == 200) {
              this.$confirm("修改成功!", "提示", {
                confirmButtonText: "继续修改",
                cancelButtonText: "返回上一页",
                type: "success",
                center: true
              }).then(() => {
                  this.reload();
                  if (document.getElementById("mainBox")) {
                    document.getElementById("mainBox").scrollTop = 0;
                  }
                })
                .catch(() => {
                  this.$router.go(-1)
                });
            } else {
              this.$message.error(res.msg || '抱歉，提交失败')
            }
          }).catch(err => {
            console.log(err)
          })

        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleImgSuccess(res, file) {
      console.log(res, file)
      if (res.errorCode == 200) {
        var url = res.data.imageFiles.split(',')[2]
        console.log(url)
        url = api.imgPrev + url
        this.ruleForm.imgPath = url
      } else {
        this.$message.error(res.errorMsg || '上传失败')
      }
    },
    handleImgError(err){
      console.log(err);
      this.$message.error('上传失败')
    },
    beforeImgUpload(file) {
      console.log(file)
      const isRequiredImg = /^image\/[jpg|jpeg|png]/.test(file.type)
      const isLt5M = file.size / 1024 / 1024 < 5
      if (!isRequiredImg) {
        this.$message.error('请上传.jpg或.png格式的图片!');
      }
      if (!isLt5M) {
        this.$message.error('上传图片大小不能超过 5MB!');
      }
      return isRequiredImg && isLt5M;
    },
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  padding: 0 16px 16px;
  background: #fff;
  .form-wrapper {
    width: 980px;
    box-sizing: border-box;
    padding: 20px;
    .w {width: 600px;}
  }
  .bottom-btns-wrap {
    width: 980px;
    box-sizing: border-box;
    padding-bottom: 20px;
    text-align: center;
    .btn-large {
      padding: 16px 120px;
    }
  }

}
</style>


// WEBPACK FOOTER //
// src/pages/news/edit.vue